module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/Z2ok1g/tc-custom/9781459238213.jpg?1740633169703",
      "alt": "This image is the cover for the book Real Vintage Maverick, Montana Mavericks: Back in the Saddle"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Real Vintage Maverick, Montana Mavericks: Back in the Saddle\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("A widowed rancher gets a second chance at love with a small town shopkeeper in this western romance from a "), _c('i', [_vm._v("USA Today")]), _vm._v("–bestselling author.")]), _c('br'), _c('br'), _c('i', [_vm._v("Thunder Canyon Nugget")]), _c('br'), _c('br'), _c('i', [_vm._v("Found: One genuine cowboy, in need of a cowgirl!")]), _c('br'), _c('br'), _vm._v("Folks in Thunder Canyon all remember the broad-shouldered, blond cowpoke with the green eyes and somber expression. We haven’t seen Cody Overton smile much in the years since he lost his wife."), _c('br'), _c('br'), _vm._v("But there’s been a strange discovery inside Catherine Clifton’s new secondhand boutique, Real Vintage Cowboy. Rumor has it that the eldest Clifton sister has found Cody Overton’s heart! Is it true that cutie Catherine has put the spring back in Cody’s boot-scootin’ step? Stay tuned, smart shoppers, and find out whether Catherine and Cody can seal the deal—and what other surprises the sassy shopkeeper might have in store!"), _c('br'), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Marie Ferrarella\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("This USA TODAY bestselling and RITA ® Award-winning author has written more than two hundred books for Harlequin Books and Silhouette Books, some under the name Marie Nicole. Her romances are beloved by fans worldwide. Visit her website at www.marieferrarella.com.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Harlequin\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5610da35","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0